import selectors from '../../rootSelectors';

import { retriableGetComplete } from './apiCallActions';

import { fetchLNContent } from '../../ln/LNActions';
import { fetchRctAccuracyContent, fetchRctFluCompContent } from '../../rct/rctActions';
import { fetchApplicationData } from '../../AppActions';
import { fetchStudentForms } from './formsActions';
import { fetchDazeContent } from '../../daze/dazeActions';
import { fetchTRCContent } from '../../trc/trcActions';
import { fetchVocabTQVMContent } from '../../vocab/tqvm/vocabTQVMActions';
import { fetchVocabFITBContent } from '../../vocab/fitb/vocabFITBActions';
import { fetchVocabBDContent } from '../../vocab/bd/vocabBDActions';
import { fetchRANContent } from '../../ran/ranActions';
import { fetchSpellingContent } from '../../spelling/spellingActions';
import { fetchMazeContent } from '../../maze/mazeActions';
import { fetchWRContent } from '../../wr/wrActions';

import {
    RCT_ACCURACY_FETCH_RETRY,
    LN_ACCURACY_FETCH_RETRY,
    RCT_FLU_COMP_FETCH_RETRY,
    APP_DATA_FETCH_RETRY,
    FORMS_DATA_FETCH_RETRY,
    DAZE_FETCH_RETRY,
    MAZE_FETCH_RETRY,
    TRCO_FETCH_RETRY,
    VOCAB_TQVM_FETCH_RETRY,
    VOCAB_FITB_FETCH_RETRY,
    VOCAB_BD_FETCH_RETRY,
    SPELLING_FETCH_RETRY,
    RAN_FETCH_RETRY,
    WR_FETCH_RETRY,
    LC_FETCH_RETRY,
    CLPL_FETCH_RETRY,
} from './apiRetryGetConstants';
import { fetchLCContent } from '../../lc/lcActions';
import { fetchCLPLContent } from '../../clpl/clplActions';

export const GET_RETRY_ACTIONS_MAP = {
    [LN_ACCURACY_FETCH_RETRY]: fetchLNContent,
    [RCT_ACCURACY_FETCH_RETRY]: fetchRctAccuracyContent,
    [RCT_FLU_COMP_FETCH_RETRY]: fetchRctFluCompContent,
    [APP_DATA_FETCH_RETRY]: fetchApplicationData,
    [FORMS_DATA_FETCH_RETRY]: fetchStudentForms,
    [DAZE_FETCH_RETRY]: fetchDazeContent,
    [TRCO_FETCH_RETRY]: fetchTRCContent,
    [VOCAB_TQVM_FETCH_RETRY]: fetchVocabTQVMContent,
    [VOCAB_FITB_FETCH_RETRY]: fetchVocabFITBContent,
    [VOCAB_BD_FETCH_RETRY]: fetchVocabBDContent,
    [RAN_FETCH_RETRY]: fetchRANContent,
    [SPELLING_FETCH_RETRY]: fetchSpellingContent,
    [MAZE_FETCH_RETRY]: fetchMazeContent,
    [WR_FETCH_RETRY]: fetchWRContent,
    [LC_FETCH_RETRY]: fetchLCContent,
    [CLPL_FETCH_RETRY]: fetchCLPLContent,
};

export const retryGetRequestAction = () => (dispatch, getStore) => {
    const state = getStore();

    const retryGetRequestActionName = selectors.getRetryGetRequestActionName(state);
    if (GET_RETRY_ACTIONS_MAP[retryGetRequestActionName]) {
        dispatch(retriableGetComplete(retryGetRequestActionName));
        dispatch(GET_RETRY_ACTIONS_MAP[retryGetRequestActionName]());
    } else {
        throw new Error(`Invalid retryGetRequestActionName, '${retryGetRequestActionName}'`
            + ', is stored in the state.');
    }
};
